import studyTime from '@/api/study-time'
import classOperation from '@/api/class-operation'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  edit_data: {},
  paymentShifts: [],
  weekday_types: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_EDIT_DATA(state, data) {
    state.edit_data = data
  },
  SET_WEEKDAY_TYPE (state, value) {
    state.weekday_types = value
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attrubutes
    )
    return studyTime.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  store(context, data) {
    return studyTime.store(data)
  },

  update(context, data) {
    return studyTime.update(data)
  },
  destroy(context, id) {
    return studyTime.destroy(id)
  },
  async paymentShift(context) {
    let weekday_type = await classOperation.getWeekdayType()
    context.commit('SET_WEEKDAY_TYPE', weekday_type.data)
    return studyTime.paymentShift()
  },
  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await studyTime.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  }
}
